module.exports = __webpack_public_path__ + "media/images/admin/icons/server-36b7f1ea5969f91128f7169e908f5014.svg";